import {
  createContext,
  useContext,
  useEffect,
  ReactNode,
  useState,
  FC,
} from "react";
import {
  PageInstallmentsAll,
  PageCommissions,
  PageContracts,
} from "src/Pages/TelasSistemas";
import { PageHelp } from "src/Pages/TelasSistemas/Help/PageHelp";
import { PagePlansConfig } from "src/Pages/TelasSistemas/Plans";
import { UrlConfig } from "src/shared/Utils/paths";

import { useAuthContext } from "../AuthContext/authContext";
import { IViews } from "../types/ProdutoresContext.Types";

import { INavigationContext } from "./ViewsTypes";
import { PageCadastro } from "src/Pages/TelasSistemas/Commissions/Cadastros/Index";
import { ContractInternal } from "src/Pages/TelasSistemas/Contracts/ContractInternal";
import { PageDashboardBroker } from "src/Pages/TelasSistemas/DashboardBroker/PageDashboard";
import { PageLeads } from "src/Pages/TelasSistemas/Leads";
import { PageDrive } from "src/Pages/TelasSistemas/Drive/Index";
import { PageCampaign } from "src/Pages/TelasSistemas/Campaign/Index";
import { PageGroupLeads } from "src/Pages/TelasSistemas/GroupLeads";
import { ProfilePage } from "src/Pages/TelasSistemas/Profile/Index";
import { TableInstancesWhats } from "src/Pages/TelasSistemas/Campaign/Instances/Components/Table/Index";
import { CampaignInternal } from "src/Pages/TelasSistemas/Campaign/CampaignInternal/CampaignInternal";
import { LandingPages } from "src/Pages/TelasSistemas/LandingPages";
import { PageRootClientes } from "src/Pages/TelasSistemas/Root/Clientes";

const ViewsProvider = createContext({} as INavigationContext);

export const ViewsContext: FC<{ children: ReactNode }> = ({ children }) => {
  const { userPerfil } = useAuthContext();

  const [NavigationComissoes, setNavigationComissoes] = useState<IViews[]>([]);
  const [navigationCampaign, setNavigationCampaign] = useState<IViews[]>([]);
  const [NavigatioPaymentsPlans, setNavigatioPaymentsPlans] = useState<
    IViews[]
  >([]);

  const [NavigationLancamentos, setNavigationLancamentos] = useState<IViews[]>(
    []
  );
  // colocar o <Page> dentro do urlConfig e usar dentro do map para n precisar passar aqui do obj e talvez nem precise desse context

  const [NavigatioPerfil, setNavigatioPerfil] = useState<IViews[]>([]);
  useEffect(() => {
    setNavigatioPerfil([
      {
        element: <ProfilePage />,
        route: UrlConfig.profile,
        isView: true,
      },
      {
        element: <PageHelp />,
        route: UrlConfig.help,
        isView: true,
      },
      {
        element: <PageDashboardBroker />,
        route: UrlConfig.dashboard,
        isView: true,
      },
      {
        element: <PageLeads />,
        route: UrlConfig.leads.leads,
        isView: true,
      },
      {
        element: <PageDrive />,
        route: UrlConfig.drive.drive,
        isView: true,
      },

      {
        element: <CampaignInternal />,
        isView: true,
        route: UrlConfig.campaign.campaign,
      },
      {
        element: <LandingPages />,
        route: UrlConfig.landingPages.landingPages,
        isView: true,
      },
      {
        element: <PageRootClientes />,
        route: UrlConfig.root.clientes,
        isView: userPerfil?.role === "ADMIN",
      },
      {
        element: <ContractInternal />,
        isView: true,
        route: UrlConfig.lancamentos.contrato,
      },
    ]);

    setNavigationCampaign([
      {
        element: <PageCampaign />,
        isView: true,
        route: UrlConfig.campaign.campaigns,
      },
      {
        element: <PageGroupLeads />,
        isView: true,
        route: UrlConfig.campaign.groupLeads,
      },
      {
        element: <TableInstancesWhats />,
        isView: true,
        route: UrlConfig.campaign.instancesWhats,
      },
    ]);

    setNavigationComissoes([
      {
        element: <PageCadastro />,
        isView: true,
        route: UrlConfig.comissao.cadastros,
      },
      {
        isView: true,
        route: UrlConfig.comissao.corretora,
        element: <PageCommissions />,
      },
    ]);

    setNavigationComissoes([
      {
        element: <PageCadastro />,
        isView: true,
        route: UrlConfig.comissao.cadastros,
      },
      {
        isView: true,
        route: UrlConfig.comissao.corretora,
        element: <PageCommissions />,
      },
    ]);

    setNavigationLancamentos([
      {
        isView: true,
        route: UrlConfig.lancamentos.contratos,
        element: <PageContracts />,
      },
      {
        isView: true,
        route: UrlConfig.lancamentos.parcelas,
        element: <PageInstallmentsAll />,
      },
    ]);

    setNavigatioPaymentsPlans([
      {
        element: <PagePlansConfig />,
        isView: true,
        route: UrlConfig.plans,
      },
    ]);
  }, [userPerfil?.email]);

  return (
    <ViewsProvider.Provider
      value={{
        NavigatioPaymentsPlans,
        NavigationLancamentos,
        NavigationComissoes,
        navigationCampaign,
        NavigatioPerfil,
      }}
    >
      {children}
    </ViewsProvider.Provider>
  );
};

export const useContextViews = (): INavigationContext =>
  useContext(ViewsProvider);
